<script setup lang="ts">
import CheckpointCard from "~/components/home/CheckpointCard.vue";
import CheckpointBlock from "~/components/home/CheckpointBlock.vue";

const summaryStore = useSummaryStore();
const { openCheckpointsSummary, summaryPending } = storeToRefs(summaryStore);

const { t } = useI18n();

await useLazyAsyncData(() => summaryStore.fetch());

useSeoMeta({
  title: () => t('home.page_title'),
  ogTitle: () => t('home.page_title'),
});
</script>

<template>
  <div>
    <div
      v-if="summaryPending"
      class="text-center"
    >
      <div
        class="spinner-border text-secondary"
        role="status"
      >
        <span class="visually-hidden">{{ t('loading_') }}</span>
      </div>
    </div>
    <div
        v-else-if="openCheckpointsSummary.length > 0"
        class="pt-2 pt-sm-0 mb-3 mb-sm-0"
    >
      <div class="row g-3 pt-2 d-none d-md-flex">
        <div
            v-for="summary in openCheckpointsSummary"
            :key="summary.code"
            class="col-12 col-md-6 col-lg-4 col-xl-3"
        >
          <CheckpointCard :summary="summary" />
        </div>
      </div>
      <div class="d-flex flex-wrap align-items-stretch w-100 d-md-none">
        <div
            v-for="summary in openCheckpointsSummary"
            :key="summary.code"
            class="card-wrapper"
        >
          <CheckpointBlock :summary="summary" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="text-center"
    >
      <h3>{{ t('error.no_data_loaded') }}</h3>
      <button
        class="btn btn-primary"
        @click="summaryStore.fetch()"
      >
        {{ t('error.try_again') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card-wrapper {
  width: 50%;
  padding-bottom: 1rem;

  &:nth-child(odd) {
    padding-right: 0.5rem;
  }
  &:nth-child(even) {
    padding-left: 0.5rem;
  }
}
</style>